// Guarded service worker registration.
// Only registers in the published app — never in Lovable preview/dev/iframe.
// Caches card art (and other images) so image-heavy Library/News pages
// load instantly on repeat visits and offline.

const SW_PATH = "/sw.js";

function shouldRegister(): boolean {
  if (typeof window === "undefined") return false;
  if (!("serviceWorker" in navigator)) return false;
  if (!import.meta.env.PROD) return false;
  try {
    if (window.top !== window.self) return false; // inside iframe (preview)
  } catch {
    return false;
  }
  const host = window.location.hostname;
  if (host.startsWith("id-preview--") || host.startsWith("preview--")) return false;
  if (host === "lovableproject.com" || host.endsWith(".lovableproject.com")) return false;
  if (host === "lovableproject-dev.com" || host.endsWith(".lovableproject-dev.com")) return false;
  if (host === "beta.lovable.dev" || host.endsWith(".beta.lovable.dev")) return false;
  if (window.location.search.includes("sw=off")) return false;
  return true;
}

async function unregisterAppSw() {
  if (!("serviceWorker" in navigator)) return;
  const regs = await navigator.serviceWorker.getRegistrations();
  await Promise.allSettled(
    regs
      .filter((r) => r.active?.scriptURL?.endsWith(SW_PATH) || r.installing?.scriptURL?.endsWith(SW_PATH) || r.waiting?.scriptURL?.endsWith(SW_PATH))
      .map((r) => r.unregister()),
  );
}

export function registerPwa() {
  if (!shouldRegister()) {
    // Make sure any stale app SW from a previous environment is cleared.
    void unregisterAppSw();
    return;
  }
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(SW_PATH, { scope: "/" }).catch(() => {
      /* ignore */
    });
  });
}
